var map = {
	"./icon-100-like.svg": 900704,
	"./icon-16-info-white.svg": 566591,
	"./icon-24-light.svg": 98029,
	"./icon-24-my-bill.svg": 180182,
	"./icon-24-wifi.svg": 792404,
	"./question-line.svg": 416773
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 582504;